//@flow
import { connect } from 'react-redux';
import config from '../../config';
import SelectCountry from './SelectCountry';
import { setRoamingPackage } from '../../modules/International/Roaming/actions';
import { getRoamingGroupCountries } from '../../lib/country-utils';

import type { DispatchProps, StateProps } from './SelectCountry';
import type { StateType } from '../../modules/reducers';

let initialCountries = getRoamingGroupCountries(config.iddCountries);

if (config.hideUnavailableRoaming) {
  initialCountries = initialCountries.filter(
    country => country.callFromAbroad === 'ROAM_LIKE_HOME' || country.callFromAbroad === 'EXTENDED_ROAM_LIKE_HOME'
  );
}

const mapStateToProps = (state: StateType): StateProps => ({
  initialCountries,
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  selectCountry: country => dispatch(setRoamingPackage(country, false)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SelectCountry);
